import React from 'react';
import DefaultButton from '../../../buttons/defaultButton/DefaultButton';
import useTranslation from '../../../../../hooks/translation/useTranslation';

function PurchaseAdditionalServices({
  additionalServices,
  purchaseAdditionalService,
}) {
  const { trans } = useTranslation();
  return (
    <div>
      <h3
        className="font-big-bold m-0"
      >
        {trans('purchase_additional_service')}
      </h3>
      <ul className="flex flex-col gap-1 list-none p-0 ">
        {
            additionalServices?.map((service) => (
              <li
                key={service.id}
                className="flex justify-between text-base items-center"
              >
                <p className="m-0">
                  {trans(service.serviceCode) !== service.serviceCode
                    ? trans(service.serviceCode) : service.serviceName}
                </p>
                {' '}
                <p className="m-0">
                  {service.amount}
                  {' '}
                  {trans('gel')}
                </p>
                {' '}
                <DefaultButton
                  className="py-2"
                  onClick={() => purchaseAdditionalService(service)}
                >
                  <p className="font-big m-0">
                    {trans('purchase')}
                  </p>
                </DefaultButton>
              </li>
            ))
        }
      </ul>
    </div>
  );
}

export default PurchaseAdditionalServices;
